import {
  WechatFileMessageType,
  WechatGifMessageType,
  WechatImageMessageType,
  WechatLinkMessageType,
  WechatMessageType,
  WechatMiniProgramMessageType,
  WechatMixedMessageType,
  WechatMsgType,
  SendContentType,
  SendingStatus,
  WechatTextMessageType,
  WechatVideoMessageType,
  WechatVideoNumMessageType,
} from "../../types";
import {
  SendWechatMessageParams,
  WechatFileSendData,
  WechatGifSendData,
  WechatLinkSendData,
  WechatMiniProgramSendData,
  WechatSendDataType,
  WechatTextMixedSendData,
  WechatTextSendData,
  WechatVideoNumSendData,
  WechatVideoSendData,
} from "./send-message";

export const makeWechatTextMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatTextSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.TEXT,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    content: send_data?.content,
  } as WechatTextMessageType;
};

export const makeWechatGifMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatGifSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.GIF,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WechatGifMessageType;
};
export const makeWechatTextMixedMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatTextMixedSendData;
  let content = "";
  const at_list = [] as { nickname: string; user_id: string }[];
  send_data?.content?.forEach(
    (item: { subtype: number; text: string; nickname?: string }) => {
      if (item.subtype === 1) {
        let id = item.text;
        if (id) {
          content += `@${item?.nickname} `;
          at_list.push({
            nickname: item?.nickname || "",
            user_id: item.text,
          });
        } else {
          content += `@所有人 `;
          at_list.push({
            nickname: " ",
            user_id: "0",
          });
        }
      } else if (item.subtype === 0) {
        // 普通文本
        content += item.text + " ";
      }
    }
  );
  return {
    at_list,
    content,
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.TEXT_2,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
  } as WechatMixedMessageType;
};

export const makeWechatImageMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatGifSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.WECHAT_IMAGE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WechatImageMessageType;
};

export const makeWechatLinkMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatLinkSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.LINK,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    ...send_data,
  } as WechatLinkMessageType;
};

export const makeWechatFileMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatFileSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.WECOM_FILE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_name: send_data?.file_name,
    file_url: send_data?.path,
  } as WechatFileMessageType;
};

export const makeWechatVideoMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatVideoSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.VIDEO,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WechatVideoMessageType;
};

export const makeWechatVideoNumMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatVideoNumSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.VIDEO_NUM,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    channel_name: send_data?.channel_name,
    channel_url: send_data?.channel_url,
    encode_data: send_data?.encode_data,
    head_img_url: send_data?.head_img_url,
    username: send_data?.username,
    thumburl: send_data?.thumb_url,
  } as WechatVideoNumMessageType;
};

export const makeWechatMiniProgarmMsg = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WechatMiniProgramSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WechatMsgType.MINI_PROGRAM,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    title: send_data.title,
    desc: send_data.desc,
    headimg: send_data.thumburl,
    appid: send_data.appid,
    cover_image_aeskey: send_data.cover_file_aeskey,
    cover_image_id: send_data.cover_file_id,
    cover_image_md5: send_data.cover_file_md5,
    cover_image_size: send_data.cover_file_size,
    username: send_data.username,
  } as WechatMiniProgramMessageType;
};

export const makeWechatMessage = (
  send_message_params: Omit<
    SendWechatMessageParams<WechatSendDataType>,
    "service_type"
  >
): WechatMessageType | undefined => {
  switch (send_message_params?.data?.type) {
    case SendContentType.TEXT: {
      return makeWechatTextMsg(send_message_params);
    }
    case SendContentType.MENTION: {
      return makeWechatTextMixedMsg(send_message_params);
    }
    case SendContentType.GIF: {
      return makeWechatGifMsg(send_message_params);
    }
    case SendContentType.IMAGE: {
      return makeWechatImageMsg(send_message_params);
    }
    case SendContentType.LINK: {
      return makeWechatLinkMsg(send_message_params);
    }
    case SendContentType.FILE: {
      return makeWechatFileMsg(send_message_params);
    }
    case SendContentType.VIDEO: {
      return makeWechatVideoMsg(send_message_params);
    }
    case SendContentType.VIDEO_NUM: {
      return makeWechatVideoNumMsg(send_message_params);
    }
    case SendContentType.MINI_PROGRAM: {
      return makeWechatMiniProgarmMsg(send_message_params);
    }
    default:
      return;
  }
};
